/** Cookie that stores the JWT — HTTP-only, never readable from client JS. */
export const AUTH_TOKEN_COOKIE = "auth_token"

export const AUTH_USER_ID_KEY = "auth_user_id"

/** Display username only (not a secret). Readable by client for UI / awareness labels. */
export const AUTH_USER_COOKIE = "auth_user"

/**
 * Reserved for refresh-token rotation (not used yet).
 * Pair with AUTH_TOKEN_COOKIE when the backend supports refresh flows.
 */
export const AUTH_REFRESH_COOKIE = "auth_refresh"

/** Default max-age when JWT has no `exp` claim (7 days). */
export const AUTH_COOKIE_DEFAULT_MAX_AGE = 60 * 60 * 24 * 7
